import isPublicView from "app/utils/publicViewUtils";
import ENV from "config";
import isEmpty from "lodash/isEmpty";
import type { Node } from "react";
import { Component } from "react";
import AriaModal from "react-aria-modal";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { SessionHelper } from "../../helpers/sessionHelper";
import { IconLogoGalaxyBet, IconSessionLogo } from "../Icon/Icon";
import "./SessionModal.scss";
type Props = {
  children: Node;
  modalOpen?: boolean;
  closeModal: (...args: Array<any>) => any;
  contentLabel: string;
  cancelButton?: boolean;
  className?: string;
  loadUserSession: (...args: Array<any>) => any;
  session: {
    status: string;
  };
};
type State = {
  modalActive: boolean;
};

class SessionModal extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      modalActive: false,
    };
    this.activateModal = this.activateModal.bind(this);
    this.deactivateModal = this.deactivateModal.bind(this);
    this.getApplicationNode = this.getApplicationNode.bind(this);
  }

  activateModal = () => {
    this.setState({
      modalActive: true,
    });
  };
  deactivateModal = () => {
    this.setState({
      modalActive: false,
    });
    window.location.reload();
  };
  getApplicationNode = () => {
    return document.getElementById("application");
  };

  componentDidUpdate() {
    if (this.props.session.status === "expired") {
      if (!this.state.modalActive) this.activateModal();
    }
  }

  componentDidMount() {
    if (isEmpty(this.props.session) && SessionHelper.isAuthenticated()) {
      !isPublicView() && this.props.loadUserSession();
    }
  }

  render() {
    const modal = this.state.modalActive ? (
      <AriaModal
        titleText="session Modal"
        onExit={this.deactivateModal}
        initialFocus="#session-modal-deactivate"
        getApplicationNode={this.getApplicationNode}
        underlayStyle={{
          paddingTop: "2em",
        }}
      >
        <div id="demo-one-modal" className="session-modal">
          <header>
            {ENV.CSS_THEME !== "GALAXYBET" && <IconSessionLogo />}
            {ENV.CSS_THEME === "GALAXYBET" && <IconLogoGalaxyBet />}
          </header>
          <div className="session-modal__body">
            <p>
              {ENV.CSS_THEME !== "GALAXYBET" && (
                <FormattedMessage tagName="span" id="users-session:expired" />
              )}
              {ENV.CSS_THEME === "GALAXYBET" && (
                <FormattedMessage
                  tagName="span"
                  id="users-session-galaxybet:expired"
                />
              )}
            </p>
          </div>

          <div className="session-session-modal_content__buttons">
            <button
              className="session-modal__cancel-button"
              id="session-modal-deactivate"
              onClick={this.deactivateModal}
            >
              Okay
            </button>
          </div>
        </div>
      </AriaModal>
    ) : (
      false
    );
    return (
      <div className="session-modal-dom-element" onClick={this.activateModal}>
        {modal}
      </div>
    );
  }
} // try and find cleaner way of doing this

const mapStateToProps = state => ({
  session: state.sessionModel.session,
});

const mapDispatchToProps = (dispatch: any) => ({
  loadUserSession: () => {
    dispatch.sessionModel.loadSession();
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(SessionModal)) as any;
